var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.608,
    height: 14.224,
    viewBox: "0 0 6.608 14.224",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4036",
    "data-name": "Path 4036",
    d: "M393.928,221.049v6.877a.179.179,0,0,0,.179.179h2.554a.179.179,0,0,0,.179-.179v-6.989h1.852a.179.179,0,0,0,.178-.164l.178-2.106a.179.179,0,0,0-.179-.194H396.84v-1.494a.634.634,0,0,1,.634-.634H398.9a.179.179,0,0,0,.179-.179V214.06a.179.179,0,0,0-.179-.179H396.49a2.562,2.562,0,0,0-2.562,2.562v2.03h-1.277a.179.179,0,0,0-.179.179v2.106a.179.179,0,0,0,.179.179h1.277Z",
    transform: "translate(-392.472 -213.881)",
    fill: "rgba(51,51,51,0.4)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbGrey);
export default __webpack_public_path__ + "static/media/fb-grey.b81815b0f3b7cc7f95e0caafef860a98.svg";
export { ForwardRef as ReactComponent };